module.exports = "../img/weber-shaping-ideas-DDB9Vqt.svg";